import styled from 'styled-components';

export const SkillProjectsPopupStyles = styled.div`
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  }

  .projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 1rem;
  }

  .project-card {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
    background: white;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
  }

  .project-image {
    width: 100%;
    height: 150px;
    overflow: hidden;
    background: #f3f4f6;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .project-content {
    padding: 1rem;

    h3 {
      margin: 0 0 0.5rem 0;
      font-size: 1.125rem;
      font-weight: 600;
      color: #111827;
    }

    .description {
      margin: 0.5rem 0;
      font-size: 0.875rem;
      color: #6b7280;
      line-height: 1.5;
    }

    .role {
      margin: 0.5rem 0;
      font-size: 0.875rem;
      color: #374151;

      strong {
        color: #111827;
      }
    }

    .status-chip {
      margin-top: 0.5rem;
      font-size: 0.75rem;
      
      &.status-completed {
        background: #d1fae5;
        color: #065f46;
      }

      &.status-in_progress {
        background: #dbeafe;
        color: #1e40af;
      }

      &.status-planned {
        background: #e5e7eb;
        color: #374151;
      }
    }

    .links {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      margin-top: 0.75rem;

      .project-link {
        font-size: 0.875rem;
        color: #2563eb;
        text-decoration: none;
        padding: 0.25rem 0.5rem;
        border: 1px solid #2563eb;
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
          background: #2563eb;
          color: white;
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 3rem 1rem;
    color: #6b7280;

    p {
      font-size: 1rem;
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    .projects-grid {
      grid-template-columns: 1fr;
    }
  }
`;
